let initialState = {
  show: false,
  item: {},
};

const freezePriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_FREEZEPRICE_PANEL': {
      return { ...state, show: true, item: action.payload };
    }
    case 'HIDE_FREEZEPRICE_PANEL': {
      return { ...state, show: false, item: {} };
    }
    case 'LOGOUT': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
export default freezePriceReducer;
